import React, { Component } from 'react';
import EmptyListComponent from '../../../../custom/empty-components/EmptyListComponent';
import CustomTable from '../../../../custom/CustomTable';
import { ColumnProps } from 'primereact/column';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { RootState } from '../../../../../redux/store';
import { ConfigurationState } from '../../../../../redux/reducers/ConfigurationReducer';
import { CaseAction, CaseActionStatus } from '../../../../../domain/case/CaseDomains';
import { changeConfiguration } from '../../../../../redux/actions/ConfigurationActions';
import DomainConfigurationActionCreatorComponent from './DomainConfigurationActionCreatorComponent';
import RoleHelper from '../../../../../RoleHelper';
import { customConfirm } from '../../../../custom/CustomPopupConfirm';
import Icon from '../../../../../icons/Icon';
import LanguageUtil from '../../../../../util/LanguageUtil';

class DomainConfigurationActionComponent extends Component<Props> {
  public render() {
    const {
      configuration: { configuration },
      changeConfiguration,
    } = this.props;
    return (
      <div className={'flex flex-col w-full h-full px-5 !max-h-[calc(100vh-18.75rem)] scrollable-editor-container overflow-y-scroll'}>
        <DomainConfigurationActionCreatorComponent domainConfiguration={configuration} changeDomain={changeConfiguration} />
        {configuration.actions.length === 0 ? (
          <EmptyListComponent />
        ) : (
          <CustomTable value={configuration.actions} columns={this.getColumns()} />
        )}
      </div>
    );
  }

  private getColumns = (): ColumnProps[] => {
    return [
      {
        field: 'name',
        header: LanguageUtil.get({ id: 'pages.configuration.action.table.name', defaultMessage: 'Action Name' }),
        className: 'w-1/3',
        body: (record: CaseAction) => {
          return <span className={'pl-4'}>{record.name}</span>;
        },
      },
      {
        field: 'status',
        header: LanguageUtil.get({ id: 'pages.configuration.action.table.status', defaultMessage: 'Status' }),
        className: 'w-1/4',
        body: (record: CaseAction) => {
          return <span>{this.getStatus(record.status)}</span>;
        },
      },
      {
        field: 'action',
        header: LanguageUtil.get({ id: 'pages.configuration.action.table.action', defaultMessage: 'Action' }),
        className: 'max-w-[75px] 2xl:max-w-[100px]',
        alignHeader: 'left',
        sortable: false,
        body: (record: CaseAction) => {
          const disabled = !RoleHelper.canEdit('CaseConfiguration');
          return (
            <div
              onClick={(e: any) => {
                e.stopPropagation();
                e.preventDefault();
                !disabled &&
                  customConfirm({
                    target: e.currentTarget,
                    accept: () => this.removeAction(record),
                    message: LanguageUtil.get({
                      id: 'messages.confirm.removeVariable',
                      defaultMessage: 'Are you sure remove this variable?',
                    }),
                  });
              }}
            >
              <Icon icon={'delete'} size={20} className={`${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} text-f-black-3`} />
            </div>
          );
        },
      },
    ];
  };

  private removeAction = (action: CaseAction) => {
    const {
      configuration: { configuration },
      changeConfiguration,
    } = this.props;
    const { actions } = configuration;
    if (!RoleHelper.canEdit('CaseConfiguration')) return;
    const index = actions.indexOf(action);
    if (index !== -1) {
      actions.splice(index, 1);
      configuration.actions = [...actions];
      changeConfiguration(configuration);
    }
  };

  private getStatus = (status: CaseActionStatus | undefined) => {
    const normalized = status || CaseActionStatus.ALL;
    switch (normalized) {
      case CaseActionStatus.ALL:
        return LanguageUtil.get({ id: 'common.label.all', defaultMessage: 'All' });
      case CaseActionStatus.FRAUD:
        return LanguageUtil.get({ id: 'common.label.fraud', defaultMessage: 'Fraud' });
      case CaseActionStatus.NOT_FRAUD:
        return LanguageUtil.get({ id: 'common.label.notFraud', defaultMessage: 'Not Fraud' });
    }
  };
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  configuration: state.configuration as ConfigurationState,
});

const mapDispatchToProps = {
  changeConfiguration,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(DomainConfigurationActionComponent);


